import DefaultLoading from "./DefaultLoading";
import React from 'react';

export default function Loadable(loader, Loading = DefaultLoading) {
  const Com = React.lazy(loader);
  return class extends React.Component {
    render() {
      return (<React.Suspense fallback={<Loading />}><Com {...this.props} /> </React.Suspense>);
    }
  };
}
